// extracted by mini-css-extract-plugin
export default {"container":"ExternalLink_container__pjGQj","linkIcon":"ExternalLink_linkIcon__NSYfu","link":"ExternalLink_link__8aQKa"};